import Reflux from 'reflux';
import BaseMixin from 'flux/stores/BaseMixin';
import EventViewActions from 'flux/actions/EventViewActions';
import EventViewStore from 'flux/stores/EventViewStore';
import TeamViewStore from 'flux/stores/TeamViewStore';
import CuesheetActions from 'flux/actions/cuesheet/CuesheetActions';
import MessageConstants from 'shared/constants/Messages';
import { Map, fromJS } from 'immutable';
import moment from 'moment-timezone';
import EventShowListActions from 'flux/actions/EventShowListActions';

const onEventViewPopulate = EventViewActions.populate;
const onCuesheetPopulateCompleted = CuesheetActions.populate.completed;
const onCuesheetPopulate = CuesheetActions.populate;
const onShowRestoreCompleted = EventShowListActions.restore.completed;

/**
 * Read Only Store
 *
 * This is used by the various components that make up the read-only
 * functionality when locking down an event/show.
 */
export default Reflux.createStore({
  mixins: [BaseMixin],

  init() {
    this.listenTo(TeamViewStore, 'onTeamViewPopulateCompleted');
    this.listenTo(EventViewStore, 'onEventViewPopulateCompleted');
    this.listenTo(onCuesheetPopulateCompleted, 'onCuesheetPopulateCompleted');
    this.listenTo(onEventViewPopulate, 'onEventViewPopulate');
    this.listenTo(onCuesheetPopulate, 'onCuesheetPopulate');
    this.listenTo(onShowRestoreCompleted, 'onShowRestoreCompleted');
    this._init();
  },

  _init() {
    this.setStateAndTrigger(
      Map({
        message: "You're currently in read-only mode.",
        readOnly: false,
      }),
    );
  },

  onCuesheetPopulateCompleted(result) {
    this.setInState('show', fromJS(result.show));
    this._setAlertMessageAndStatus();
  },

  onCuesheetPopulate() {
    this._init();
  },

  onTeamViewPopulateCompleted(result) {
    this.setInState('team', fromJS(result));
    this._setAlertMessageAndStatus();
  },

  onEventViewPopulateCompleted(result) {
    this.setInState('event', fromJS(result));
    this._setAlertMessageAndStatus();
  },

  onEventViewPopulate() {
    this._init();
  },

  onShowRestoreCompleted() {
    const { teamId, eventId } = this._getShowParams();
    window.location.href = `/dash/team/${teamId}/event/${eventId}/dashboard`;
  },

  _setAlertMessageAndStatus() {
    let next = this.getState();

    if (this._isDeletedEvent()) {
      next = this._setReadOnly(next);
      next = next
        .set('message', MessageConstants.readOnlyDeletedEventAlertBar)
        .set('modalMessage', MessageConstants.readOnlyDeletedEventModal);
    } else if (this._isPastEvent()) {
      next = this._setReadOnly(next);
      next = next
        .set('message', MessageConstants.readOnlyPastEventAlertBar)
        .set('modalMessage', MessageConstants.readOnlyPastEventModal);
    } else if (this._isArchivedShow()) {
      next = this._setReadOnly(next);
      next = next
        .set('message', MessageConstants.readOnlyDeletedShowAlertBar)
        .set('modalMessage', MessageConstants.readOnlyDeletedShowModal)
        .set('showParams', this._getShowParams());
    } else if (this._isSavedShow()) {
      next = this._setReadOnly(next);
      next = next
        .set('message', MessageConstants.readOnlySavedShowAlertBar)
        .set('modalMessage', MessageConstants.readOnlySavedShowModal);
    }

    this.setStateAndTrigger(next);
  },

  _isDeletedEvent() {
    return this.getInState(['event', 'deleted']);
  },

  _isPastEvent() {
    let endOn = this.getInState(['event', 'endOn']);
    return moment(endOn).isBefore(
      moment().hour(0).minute(0).subtract(7, 'days'),
    );
  },

  _isArchivedShow() {
    return this.getInState(['show', 'archived']);
  },

  _isSavedShow() {
    return this.getInState(['show', 'saved']);
  },

  _setReadOnly(next) {
    if (next) return next.set('readOnly', true);
    this.setInStateAndTrigger('readOnly', true);
  },

  _getShowParams() {
    const teamId = this.getInState(['team', '_id']);
    const eventId = this.getInState(['event', '_id']);
    const showId = this.getInState(['show', '_id']);
    const displayType = this.getInState(['show', 'displayType']);

    return { teamId, eventId, showId, displayType };
  },
});
